<template>
  <div v-if="film">
    <v-container>
      <v-row>
        <v-col offset="1" cols="10">
          <v-container>
            <v-row>
              <v-col v-if="film.poster" sm="12" md="3">
                <v-img :src="film.poster" />
              </v-col>
              <v-col sm="12" :md="film.poster ? 9 : 12">
                <v-container>
                  <v-row style="border-bottom: 1px solid grey">
                    <v-col cols="8">
                      <v-dialog :width="400">
                        <template #activator="{ on, attrs }">
                      <span v-on="on" v-bind="attrs" class="display-1">{{ film.title }}</span>
                        </template>
                        <v-card>
                          <v-card-title>
                            External Links
                          </v-card-title>
                          <v-card-text>
                            <v-container class="text-center">
                              <v-row>
                                <v-col>
                                  TheMovieDB: {{ film.tmdb_id }}
                                  <a
                                    target="_blank"
                                    :href="'https://www.themoviedb.org/movie/' + film.tmdb_id"
                                  ><v-icon>mdi-open-in-new</v-icon></a>
                                </v-col>
                              </v-row>
                              <v-row v-if="film.imdb_id">
                                <v-col>
                                  IMDB: {{ film.imdb_id }}
                                  <a
                                    target="_blank"
                                    :href="'https://www.imdb.com/title/' + film.imdb_id"
                                  ><v-icon>mdi-open-in-new</v-icon></a>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-text>
                        </v-card>
                      </v-dialog>
                      <span v-if="hasOriginalTitle">
                        ({{ film.original_title }})
                      </span>
                    </v-col>
                    <v-col cols="2" class="text-center">
                      <span v-if="film.runtime" class="headline">
                        <span class="body-1">
                          {{ film.runtime }} Minutes
                        </span>
                      </span>
                    </v-col>
                    <v-col cols="2" class="text-right">
                      <span class="headline">
                        <router-link
                          class="body-1"
                          :to="links.dateLink(film.release_date)"
                        >{{ film.release_date }}</router-link>
                      </span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <p class="text-justify">
                        {{ film.plot }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-list-item
                        v-for="genre in film.genres" :key="genre"
                        class="denser"
                      >
                        <router-link
                          class="mx-auto"
                          :to="links.genreLink(genre)"
                        >{{ genre }}</router-link>
                      </v-list-item>
                    </v-col>
                    <v-col>
                      <v-list-item
                        v-for="country in film.countries" :key="country"
                        class="denser"
                      >
                        <router-link
                          class="mx-auto"
                          :to="links.countryLink(country)"
                        >{{ country }}</router-link>
                      </v-list-item>
                    </v-col>
                    <v-col>
                      <v-list-item
                        v-for="language in film.languages" :key="language"
                        class="denser"
                      >
                        <router-link
                          class="mx-auto"
                          :to="links.languageLink(language)"
                        >{{ language }}</router-link>
                      </v-list-item>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      v-for="c in crew" :key="c[0]"
                      cols="4"
                    >
                      <v-list-item>
                        <v-list-item-content class="text-center">
                          <v-list-item-title>
                            <router-link :to="links.personLink(c[0])">
                              {{ c[0] }}
                            </router-link>
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            {{ c.slice(1).join(', ') }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                  <v-divider />
                  <v-row>
                    <v-col class="text-center">
                      <v-menu v-if="film.avg_rating || film.avg_rating === 0" offset-y>
                        <template #activator="{ on }">
                          <v-btn v-on="on" text :disabled="ratings.length === 0">
                            <film-rating
                              :id="film.id"
                              :rating="film.avg_rating"
                            />
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item
                            v-for="rating in ratings"
                            :key="'rating' + rating.user_id"
                          >
                            <v-list-item-content>
                              <v-list-item-title>
                                <film-rating
                                  :id="film.id"
                                  :rating="rating.rating"
                                />
                              </v-list-item-title>
                              <v-list-item-subtitle>
                                By <a>{{ rating.user_name }}</a>
                                <small class="float-right">{{ $moment(rating.created).fromNow() }}</small>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-col>
                    <v-divider vertical />
                    <v-col class="text-center">
                      <film-ownership
                        :id="film.id"
                        :owned="film.owned"
                        @updateFilm="updateFilm"
                      >
                        <template #on>
                          <span class="green--text">You own this film</span>
                        </template>
                        <template #off>
                          You do not own this film
                        </template>
                      </film-ownership>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="text-center">
                      <my-rating
                        :id="film.id"
                        :rating="rated"
                        @updateFilm="updateFilm"
                      />
                    </v-col>
                    <v-divider vertical />
                    <v-col class="text-center">
                      <v-menu offset-y>
                        <template #activator="{ on }">
                          <v-btn text v-on="on">
                            Suggest
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item
                            v-for="user in users"
                            :key="'suguser' + user.id"
                            dense
                            @click="suggest(user)"
                          >
                            <v-list-item-title>
                              {{ user.name }}
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-divider/>
                </v-container>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <div class="actor-container">
                  <div
                    v-for="actor in visibleActors" :key="actor.name"
                    class="actor-card"
                  >
                    <v-hover>
                      <template v-slot:default="{ hover }">
                        <v-card
                          flat
                          min-width="160"
                          width="160"
                          height="100%"
                        >
                          <v-img
                            v-if="actor.poster"
                            :src="actor.poster"
                          />
                          <v-sheet
                            v-else
                            width="160"
                            height="240"
                            color="grey"
                          />
                          <v-card-text class="body-1 text-center">
                            {{ actor.name }}
                          </v-card-text>
                          <v-card-subtitle v-if="actor.character" class="text-center">
                            as <em>{{ actor.character }}</em>
                          </v-card-subtitle>
                          <v-fade-transition>
                            <v-overlay v-if="hover" absolute>
                              <v-btn
                                :to="links.personLink(actor.name)"
                              >See Films</v-btn>
                            </v-overlay>
                          </v-fade-transition>
                        </v-card>
                      </template>
                    </v-hover>
                  </div>
                  <div v-if="hasMoreAcotrs" class="actor-card">
                    <v-card
                      flat
                      min-width="160"
                      width="160"
                      height="100%"
                    >
                      <v-btn
                        height="240"
                        width="160"
                        elevation="0"
                        @click="showAllActors"
                      >Show All</v-btn>
                    </v-card>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
      <v-divider />
      <v-row>
        <v-col cols="3"></v-col>
        <v-col cols="6" class="text-center">
          <film-tags
            :id="id"
            :tags="film.tags" 
            @addTag="addTag"
            @removeTag="removeTag"
            @editTag="editTag"
          />
        </v-col>
      </v-row>
      <v-divider />
      <v-row>
        <v-col>
          <my-review 
            :film_id="id"
            :review="reviewed"
            @deleteReview="deleteReview"
            @updateReview="updateReview"
            @addReview="addReview"
          />
        </v-col>
      </v-row>
      <v-row v-for="review in reviews" :key="'review' + review.user_id">
        <v-col>
          <film-review :review="review" />
        </v-col>
      </v-row>
      <v-divider />
      <v-row>
        <v-col cols="3"></v-col>
        <v-col cols="6">
          <film-lists
            :id="this.id"
            :lists="film.lists"
            @addList="addList"
            @removeList="removeList"
          />
        </v-col>
      </v-row>
      <v-divider />
      <v-row>
        <v-col>
          <v-img v-if="film.backdrop" :src="film.backdrop" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import FilmRating from "@/components/details/FilmRating"
import FilmReview from "@/components/details/FilmReview"
import MyRating from "@/components/details/MyRating"
import MyReview from "@/components/details/MyReview"
import FilmOwnership from "@/components/details/FilmOwnership"
import FilmLists from "@/components/details/FilmLists"
import FilmTags from "@/components/details/FilmTags"
import links from "@/utils/Links"

export default {
  name: "Film",
  components: {
    FilmRating,
    FilmReview,
    MyRating,
    MyReview,
    FilmOwnership,
    FilmLists,
    FilmTags,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  data () {
    return {
      film: null,
      actorsShown: 6,
      users: null,
    }
  },
  inject: ["httpClient", "snackbar"],
  mounted () {
    this.httpClient.loadUsers().then(data => this.users = data)
    this.load()
  },
  computed: {
    me() {
      return this.$store.state.me
    },
    links() {
      return links
    },
    hasOriginalTitle() {
      return this.film.original_title &&
             this.film.title != this.film.original_title
    },
    crew () {
      const crews = []
      const add = (name, job) => {
        const prev = crews.find(c => c[0] === name)
        if (prev) {
          prev.push(job)
        } else {
          crews.push([name, job])
        }
      }
      for (
        var i = 0;
        i < this.film.directors.length || i < this.film.writers.length;
        i++
      ) {
        if (i < this.film.directors.length) {
          add(this.film.directors[i].name, "Director")
        }
        if (i < this.film.writers.length) {
          add(this.film.writers[i].name, "Writer")
        }
      }
      return crews
    },
    visibleActors () {
      return this.film.actors.slice(0, this.actorsShown)
    },
    hasMoreAcotrs () {
      return this.film.actors.length > this.actorsShown
    },
    ratings() {
      if (this.film.ratings) {
        return this.film.ratings.filter(r => r.user_id !== this.me.id)
      } else {
        return []
      }
    },
    rated() {
      const my = this.film.ratings.find(r => r.user_id === this.me.id)
      return my ? my.rating : null
    },
    reviews() {
      return this.film.reviews
        .filter(r => r.user_id !== this.me.id)
        .map(r => {
          const rating = this.ratings.find(rr => rr.user_id === r.user_id)
          if (rating) r.rating = rating.rating
          return r
        })
    },
    reviewed() {
      const my = this.film.reviews.find(r => r.user_id === this.me.id)
      if (my) {
        if (this.rated || this.rated === 0) my.rating = this.rated
        return my
      }
      return {review: ""}
    },
    reviewedText() {
      return this.reviewed ? this.reviewed.review : ""
    },
  },
  methods: {
    async load () {
      this.film = await this.httpClient.loadFilm({id: this.id})
      this.actorsShown = this.film.actors.length > 7 ? 6 : this.film.actors.length
    },
    showAllActors () {
      this.actorsShown = this.film.actors.length
    },
    async suggest(user) {
      await this.httpClient.suggestFilm({
        id: this.id,
        user_id: user.id
      })
      this.snackbar(`You have suggested ${this.film.title} to ${user.name}`, "success")
    },
    updateFilm(data) {
      this.film = Object.assign(this.film, data)
    },
    deleteReview() {
      this.film.reviews =
        this.film.reviews.filter(r => r.user_id !== this.me.id)
    },
    updateReview({review}) {
      this.film.reviews = this.film.reviews.map(r => {
        if (r.user_id === this.me.id) r.review = review
        return r
      })
    },
    addReview({review}) {
      this.film.reviews.splice(0, 0, {
        user_id: this.me.id,
        review,
      })
    },
    addList({list}) {
      this.film.lists.splice(0, 0, list)
    },
    removeList({id}) {
      this.film.lists = this.film.lists.filter(l => l.id !== id)
    },
    addTag(tag) {
      this.film.tags.splice(this.film.tags.length, 0, tag)
    },
    removeTag(tag) {
      const ind = this.film.tags.findIndex(t => t.id == tag.id)
      if (ind != -1) this.film.tags.splice(ind, 1)
    },
    editTag({old_tag, new_tag}) {
      this.removeTag(old_tag)
      this.addTag(new_tag)
    },
  },
  watch: {
    id() {
      this.load()
    },
  },
}
</script>

<style>
.v-list-item.denser {
  min-height: 0;
}
div.actor-container {
  display: flex;
  overflow-x: auto;
}
div.actor-card {
  margin: 0 auto 0 10px;
}
</style>
